<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">カウメモ反映</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body">
    <div class="dialog-content-header">
      <span class="dialog-content-header__radio-select">
        <input
          type="radio"
          [(ngModel)]="selectedUploadType"
          [value]="UploadType.REGISTER"
          name="selectedUploadTypeRadio"
          id="uploadTypeRegister">
        <label for="uploadTypeRegister">初回アップロード</label>
      </span>
      <span class="dialog-content-header__radio-select">
        <input
          type="radio"
          [(ngModel)]="selectedUploadType"
          [value]="UploadType.UPDATE"
          name="selectedUploadTypeRadio"
          id="uploadTypeUpdate">
        <label for="uploadTypeUpdate">2回目以降のアップロード</label>
      </span>
    </div>
    <div class="dialog-content-section">
      <span class="dialog-content-section-text">「カウンセリング内容」を記入してください</span>
      <div class="dialog-content-field">
        <span class="dialog-content-field__head">カウンセリング内容</span>
        <span class="dialog-content-field__body">
          <textarea
            rows="10"
            [(ngModel)]="memoRaw"
            id="memoRaw"
          ></textarea>
        </span>
      </div>
    </div>
  </div>
  <div class="dialog__footer">
    <button class="dialog__button dialog__button--accent" (click)="close()">
      キャンセル
    </button>
    <button
      [disabled]="!memoRaw"
      class="dialog__button dialog__button--primary"
      (click)="reflect()"
    >
      カウ処理開始
    </button>
  </div>
</div>
